<template>
  <div class="view-about mt-5 text-center">
    <h1> version{{ VERSION }} </h1>
    <h2> v{{ VERSION }} </h2>
  </div>
</template>

<script>
export default {
  name: 'AboutPage',
  data () {
    return {
      VERSION: VERSION,
    }
  }
}
</script>
